import { REGISTER_SMS, VERIFY_SMS, VERIFICATION_SUCCESSFUL } from './SecurityPhoneNumberSetupSteps';
const STEP_ORDER = [REGISTER_SMS, VERIFY_SMS, VERIFICATION_SUCCESSFUL];
export function indexOfStep(step) {
  return STEP_ORDER.indexOf(step);
}
export default STEP_ORDER;